module.exports = __webpack_public_path__ + "img/icon-eye.f02ee61a.svg";